import Pagination from './Pagination.vue'

export default {
  install(Vue) {
    Vue.component(Pagination.name, Pagination)
  }
}
